export default __webpack_public_path__ + "static/media/cushion.0074da01.svg";